export default "__VITE_ASSET__SD_xEsFU__"